import { getAuthHeaders, getAxios } from '@/helpers/axios-helper';
import { DEFAULT_USERSETTINGS, UserSettings } from '@/stores/useUserStoreTypes';

export async function getSettings(justwatchId = '', locale = '', accessToken = ''): Promise<UserSettings> {
	// don't fetch personalized data when jwId is not available
	if (!justwatchId) {
		return Promise.resolve(DEFAULT_USERSETTINGS);
	}

	const headers = await getAuthHeaders(accessToken);
	const config = { params: { justwatch_id: justwatchId }, headers };

	try {
		const response = await getAxios().get(`${JW_CONFIG.WRITE_URL}/settings/${locale}`, config);
		const {
			onboarding_status,
			taste_survey_completed: _taste_survey_completed,
			taste_survey_model_version: _taste_survey_model_version,
			taste_survey_type: _taste_survey_type,
			hidden_timeline_specials: _hidden_timeline_specials,
			...settings
		} = response.data;

		return { ...settings, onboardingStatus: onboarding_status };
	} catch (error: any) {
		const { captureMessageForSentry } = await import('@/helpers/sentry-helper');

		const status = error.response?.status;
		captureMessageForSentry(`[getSettings()] - ${status}`, { error, where: 'settings-helper.ts' }, 'error');

		return Promise.resolve(DEFAULT_USERSETTINGS);
	}
}

export async function mutateSettings(
	justwatchId = '',
	accessToken = '',
	locale = '',
	currentSettings: UserSettings,
	newSettings: Partial<UserSettings>
) {
	if (!justwatchId) {
		return Promise.resolve(currentSettings || DEFAULT_USERSETTINGS);
	}
	const headers = await getAuthHeaders(accessToken);
	const config = { params: { justwatch_id: justwatchId }, headers };

	const mutations = [];
	for (const [field, value] of Object.entries(newSettings)) {
		if (field === 'onboardingStatus') {
			mutations.push({
				field: 'onboarding_status',
				unset: (currentSettings as any)['onboarding_status'],
				set: value,
			});
		} else {
			mutations.push({
				field: field,
				unset: (currentSettings as any)[field],
				set: value,
			});
		}
	}

	try {
		const response = await getAxios().post(
			`${JW_CONFIG.WRITE_URL}/settings/${locale}/mutate`,
			{ mutations },
			config
		);
		const {
			onboarding_status,
			taste_survey_completed: _taste_survey_completed,
			taste_survey_model_version: _taste_survey_model_version,
			taste_survey_type: _taste_survey_type,
			hidden_timeline_specials: _hidden_timeline_specials,
			...settings
		} = response.data;
		return { ...settings, onboardingStatus: onboarding_status };
	} catch (error: any) {
		const { captureMessageForSentry } = await import('@/helpers/sentry-helper');

		const status = error.response?.status;
		captureMessageForSentry(`[mutateSettings()] - ${status}`, { error, where: 'settings-helper.ts' }, 'error');

		return Promise.resolve(currentSettings || DEFAULT_USERSETTINGS);
	}
}
